import type { ServiceDefinition } from "../types";
import { bortforsling } from "./bortforsling";
import { bortforslingMobler } from "./bortforsling-mobler";

export const allServices: ServiceDefinition[] = [
  bortforsling,
  bortforslingMobler,
];
